<ng-template #reportCardCompact let-characteristics="characteristics"></ng-template>
<ng-template #reportCardExpanded let-cardItem>
    <al-base-card
        [config]="configAlBaseCard"
        [item]="cardItem"
        [iconFunction]="iconCardFunction"
        [footerFunction]="functionFooterActions"
        [checked]="cardItem.checked"
        (onChangeChecked)="changeSimpleSelection($event)"
        (onFooterAction)="actionFooterEvent($event)"
        (onExpand)="itemExpanded($event)">
        <ng-template alBaseCardBodyContent>
            <al-saved-searches-content [item]="cardItem" (onEditSchedule)="onEditScheduleSavedSearch($event)"></al-saved-searches-content>
        </ng-template>
        <ng-template alBaseCardHeaderRight>
            <div class="u-col-1 u-cursor-pointer u-w-18 u-text-center u-border-r u-border-solid u-border-primary">
                <div class="al-cardstack-icon"
                    (click)="onSearchSavedSearch(cardItem)">
                    <i class="pi pi-search"></i>
                    <div class="al-cardstack-icon-label u-text-xxs u-text-secondary">Search</div>
                </div>
            </div>
            <div class="u-col-1 u-cursor-pointer u-w-18 u-text-center u-border-r u-border-solid u-border-primary" 
                *ngIf="cardItem.properties?.schedulesTotal"
                (click)="cardItem.expanded = true && configAlBaseCard.toggleable">
                <div class="al-cardstack-icon"
                    (click)="onSearchSavedSearch(cardItem)">
                    <div>{{ cardItem.properties?.schedulesTotal }} <i class="material-icons">date_range</i></div>
                    <div class="al-cardstack-icon-label u-text-xxs u-text-secondary">Schedule{{cardItem.properties?.schedulesTotal !== 1 ? 's' : ''}}</div>
                </div>
            </div>
        </ng-template>
    </al-base-card>
</ng-template>

<al-view-helper [error]="viewError"></al-view-helper>

<al-cardstack #alCardstack
    [view]="savedSearchCardstack"
    [cardExpanded]="reportCardExpanded"
    (onCheckAll)="changeAllSelection($event)"
    (onScrollDown)="changeAllSelection()">
    <div class="zero-state">
        <al-zero-state>
            <i zero-state-icon class="material-icons">{{zeroStateConfig.icon}}</i>
            <div zero-state-title>
                No {{zeroStateConfig.entityNamePlural}} were found.
            </div>
        </al-zero-state>
    </div>
</al-cardstack>

<p-confirmDialog #confirmDialog
    [acceptButtonStyleClass]="'primaryAction'"
    [style]="{'width':'500px'}">
    <p-footer>
        <button pButton
        type="button"
        [label]="confirmDialog.rejectLabel"
        (click)="confirmDialog.reject()">
    </button>
    <button pButton
        type="button"
        class="primaryAction"
        [label]="confirmDialog.acceptLabel"
        (click)="confirmDialog.accept()">
    </button>
    </p-footer>
</p-confirmDialog>

<al-toast key="saved_searches"></al-toast>

<al-action-snackbar
    [text]="actionSnackbarText"
    [visible]="actionSnackbarVisible"
    [elements]="actionSnackbarButtons"
    (onElementPressed)="actionSnackbarEvent($event)">
</al-action-snackbar>

<al-saved-searches-form
    #savedSearchForm
    [accountId]="accountId"
    (goToSchedule)="goToSchedule($event)"
    (onSuccess)="onCreateSavedSearchSuccess($event)"
    (onError)="onCreateSavedSearchError($event)"
    (onCancel)="onCreateSavedSearchCancel()">
</al-saved-searches-form>

<al-notification-report-schedule-form
    #savedSearchScheduleForm
    [accountId]="accountId"
    [isFim]="false"
    (onSuccess)="onCreateSavedSearchSuccess($event)"
    (onError)="onCreateSavedSearchError($event)"
    (onCancel)="onCreateSavedSearchCancel()">
</al-notification-report-schedule-form>
